const appsPageSlugs = new Set(['list', 'pull-requests', 'quality-review', 'quality-stats', 'general-stats', 'app-logo-colors', 'stats']);

export default appsPageSlugs;
